<template>
  <permissions-view
    :site="site"
    :section="section"
  >
    <loader v-if="loading"></loader>
    <v-container>
      <v-row>
        <v-col cols="3">
          <display-field label="RBSName">{{ radioFrequency.RBSName|noDataAvailable }}</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="RBSType">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Battery Backup">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Comments">Data not available</display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field label="DateActive">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Function ID">{{ site.function_id }}</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Function Type">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Output Power Antenna EIRP">Data not available</display-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <display-field label="Repeater Model">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="RepeaterCarriers">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Status">Data not available</display-field>
        </v-col>
        <v-col cols="3">
          <display-field label="Technology">Data not available</display-field>
        </v-col>
      </v-row>
      <sector-info
        :site="site"
        :auto-open="autoOpen"
      ></sector-info>
    </v-container>

  </permissions-view>
</template>

<script>
  import PermissionsView from '@/components/PermissionsView'
  import DisplayField from '@/components/DisplayField'
  import SectorInfo from '@/views/sites/sections/radio-frequency/SectorInfo'
  import Loader from '@/components/Loader'
  import SiteNwpService from '@/services/site-nwp'

  export default {
    name: 'RadioFrequency',
    components: { Loader, SectorInfo, DisplayField, PermissionsView },
    data: function () {
      return {
        section: 'transmission',
        loading: false,
        radioFrequency: undefined,
      }
    },
    props: {
      site: {
        default: null,
      },
      autoOpen: {
        default: false,
      },
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        this.loading = true
        const acs = new SiteNwpService()
        return acs.radioFrequencyDetails(this.site.id).then((response) => {
          this.radioFrequency = response.data.data
        }).finally(() => {
          this.loading = false
        })
      },
    },
  }
</script>

<style scoped>

</style>
